import useFrameworkSkills from './useFrameworkSkills'
import { getFrameworkSkillWithGroup } from '../../utils/skills'

export default frameworkSkillId => {
  const { frameworkSkills, frameworkSkillGroups } = useFrameworkSkills()
  
  return getFrameworkSkillWithGroup(
    frameworkSkillId,
    frameworkSkills,
    frameworkSkillGroups
  )
}
